import * as actionTypes from './actionTypes';
import { RegisterFormType } from './types';
import { Action } from '../../common/types/types';

export const register = (payload: RegisterFormType): Action => ({
  type: actionTypes.REGISTER_START,
  payload,
});
